import { render } from "./instructor-reviews.vue?vue&type=template&id=0bb28b5c"
import script from "./instructor-reviews.vue?vue&type=script&lang=js"
export * from "./instructor-reviews.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__